import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
  name: "workflowEngine",
  initialState: {
    list: [],
    loading: false,
    reAssignLoading: false,
    lastFetch: null,
    ruleAppData: "",
    currentWfTask: "",
    taskAssignHistory: [],
    reAssignStatus: false,
    tskDoneStatus: false,
    workflowData: "",
    workflowDoneTask: "",
  },
  reducers: {
    taskReceived: (workflowEngine, action) => {
      workflowEngine.list.push(action.payload);
    },
    taskDone: (workflowEngine, action) => {
      workflowEngine.tskDoneStatus = false;
      workflowEngine.currentWfTask = "";

      if (action.payload?.status) {
        workflowEngine.tskDoneStatus = true;
      }

      if (action.payload?.id > 0) {
        workflowEngine.currentWfTask = action.payload;
        workflowEngine.tskDoneStatus = true;
      }
    },
    ruleAppDataReceived: (workflowEngine, action) => {
      workflowEngine.ruleAppData = action.payload;
    },
    currentWfTaskReceived: (workflowEngine, action) => {
      workflowEngine.currentWfTask = action.payload;
    },
    taskAssignHistoryRequestStarted: (workflowEngine) => {
      workflowEngine.loading = true;
    },
    taskAssignHistoryRequestFailed: (workflowEngine) => {
      workflowEngine.loading = false;
    },
    taskAssignHistoryReceived: (workflowEngine, action) => {
      workflowEngine.taskAssignHistory = action.payload;
      workflowEngine.reAssignStatus = false;
      workflowEngine.loading = false;
    },
    taskReAssignRequestStarted: (workflowEngine) => {
      workflowEngine.reAssignLoading = true;
    },
    taskReAssignRequestFailed: (workflowEngine) => {
      workflowEngine.reAssignLoading = false;
    },
    taskReAssigned: (workflowEngine, action) => {
      workflowEngine.reAssignStatus = true;
      workflowEngine.reAssignLoading = false;
    },
    workflowDataReceived: (workflowEngine, action) => {
      workflowEngine.workflowData = action.payload;
    },
    workflowDoneTaskReceived: (workflowEngine, action) => {
      workflowEngine.workflowDoneTask = action.payload;
    },
  },
});

export const {
  taskReceived,
  taskDone,
  ruleAppDataReceived,
  currentWfTaskReceived,
  taskAssignHistoryRequestStarted,
  taskAssignHistoryRequestFailed,
  taskAssignHistoryReceived,
  taskReAssignRequestStarted,
  taskReAssignRequestFailed,
  taskReAssigned,
  workflowDataReceived,
  workflowDoneTaskReceived,
} = slice.actions;
export default slice.reducer;

export const workflowTaskDone = (data) =>
  apiCallBegan({
    url: config.SetWorkItemToDone,
    method: "post",
    data: data,
    onSuccess: taskDone.type,
  });

export const loadCurrentWorkflowTask = (data) =>
  apiCallBegan({
    url: config.GetCurrentWorkflowTask,
    method: "post",
    data: data,
    onSuccess: currentWfTaskReceived.type,
  });

export const executeBprmFormRule = (data) =>
  apiCallBegan({
    url: config.ExcuteFormRule,
    method: "post",
    data: data,
    onSuccess: ruleAppDataReceived.type,
  });

export const loadTaskReAssignHistory = (wiid) =>
  apiCallBegan({
    url: config.GetTaskReAssignHistory + wiid,
    onStart: { type: taskAssignHistoryRequestStarted.type },
    onError: { type: taskAssignHistoryRequestFailed.type },
    onSuccess: taskAssignHistoryReceived.type,
  });

export const taskReAssign = (data) =>
  apiCallBegan({
    url: config.ReAssignTask,
    method: "post",
    data: data,
    onStart: { type: taskReAssignRequestStarted.type },
    onError: { type: taskReAssignRequestFailed.type },
    onSuccess: taskReAssigned.type,
  });

export const loadWorkflow = (ciid) =>
  apiCallBegan({
    url: config.GetWorkflow + ciid,
    onSuccess: workflowDataReceived.type,
    throwOnError: true,
  });

export const loadWorkflowDoneTask = (ciid) =>
  apiCallBegan({
    url: config.GetWorkflowDoneTask + ciid,
    onSuccess: workflowDoneTaskReceived.type,
    throwOnError: true,
  });

export const getExecuteRuleAppData = createSelector(
  (state) => state.entities.workflowEngine,
  (workflowEngine) => workflowEngine.ruleAppData,
);

export const getCurrentWorkflowTask = createSelector(
  (state) => state.entities.workflowEngine,
  (workflowEngine) => workflowEngine.currentWfTask,
);

export const getTaskAssignHistory = createSelector(
  (state) => state.entities.workflowEngine,
  (workflowEngine) => workflowEngine.taskAssignHistory,
);
export const getTaskAssignHistoryLoading = createSelector(
  (state) => state.entities.workflowEngine,
  (workflowEngine) => workflowEngine.loading || false,
);
export const getTaskAssignStatus = createSelector(
  (state) => state.entities.workflowEngine,
  (workflowEngine) => workflowEngine.reAssignStatus,
);

export const getTaskReAssignLoading = createSelector(
  (state) => state.entities.workflowEngine,
  (workflowEngine) => workflowEngine.reAssignLoading || false,
);

export const getTaskDoneStatus = createSelector(
  (state) => state.entities.workflowEngine,
  (workflowEngine) => workflowEngine.tskDoneStatus,
);

export const getWorkflowData = createSelector(
  (state) => state.entities.workflowEngine,
  (workflowEngine) => workflowEngine.workflowData,
);

export const getWorkflowDoneTask = createSelector(
  (state) => state.entities.workflowEngine,
  (workflowEngine) => workflowEngine.workflowDoneTask,
);
